"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  day: null,
  startMinute: null,
  endMinute: null
}, 'AvailableTimeChunk');

exports.default = _default;
module.exports = exports.default;